import React, { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

export const BackToTop = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
      data-testid="back-to-top"
      className="fixed bottom-4 left-4 z-30 inline-flex h-12 w-12 items-center justify-center rounded-full bg-stone-900 text-white shadow-lg transition-colors hover:bg-stone-800"
    >
      <ArrowUp className="h-5 w-5" aria-hidden="true" />
    </button>
  );
};
